export default __webpack_public_path__ + "f69788e7dd5b34badabdfbbaed30bd16.svg";